import {Injectable} from '@angular/core';

@Injectable()
export class GlobalComponentView {
  static renderAllowed = false;
  static cdr = null;

  static setRenderAllowed() {
    GlobalComponentView.renderAllowed = true;
    GlobalComponentView.cdr.detectChanges();
  }
}
